<template>
    <div style="display: flex; flex-direction: column; align-items: center;">
        <Transition name="fade">
            <div @click="closeModal" v-if="isOpen" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        </Transition>
        <div class="default_img" :class="{ open: isOpen }">
            <div v-if="!noTitle" style="border-bottom: 1px solid #f5f5f5; padding-bottom: 12px; text-align: center; font-weight: 700;">{{ title }}</div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditModalFrame',
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeModal: {
            type: Function,
            default: () => { }
        },
        title: {
            type: String,
            default: ''
        },
        changeHeight: {
            type: Number,
            default: 600
        },
        noTitle: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.default_img {
    background-color: #fff;
    padding: 12px;
    border-radius: 20px;
    width: calc(100% - 40px);
    /* width: 350px; */
    position: fixed;
    top: 100%;
    transform: translateY(0);
    transition: 0.5s all;
    z-index: 20;
}

.default_img.open {
    top: 50%;
    transform: translateY(-50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>